<!-- 用户收藏夹模版 -->
<template>
  <div id="imgBoxListPanFav">
    <div id="imgBoxListFav">
      <div v-show="isNoResult" id="resInfoFav">您的收藏夹还是空的吆 ...</div>
      <ul style="margin-block-start: 0em;">
        <li v-for="(ibean, key, index) in swImgs" v-bind:key="ibean.ufId">
          <Imgbox
            :fid="ibean.ufId"
            :imgId="ibean.ufComment"
            :imgInfo="ibean.ufImageInfo"
            :index="index"
            @delEvent="delFavorite"
          ></Imgbox>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import imgbox from './rely/imgBox'
export default {
  components: {
    Imgbox: imgbox
  },
  data () {
    return {
      swImgs: [],
      isNoResult: false
    }
  },
  methods: {
    doLoadFav () {
      const api = '/md/front/additional/collection/list'
      this.axios.post(api).then(res => {
        if (res.status === 200) {
          this.isNoResult = false
          this.swImgs = res.data
        } else {
          this.isNoResult = true
          this.swImgs = []
        }
      })
    },
    delFavorite (id) {
      const api = '/md/front/additional/collection/del'
      const params = {
        cid: id
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          // 删除成功
          this.$alert('删除成功', '提示')
          const index = this.swImgs.findIndex(item => {
            if (item.ufId === id) {
              return true
            }
          })
          this.swImgs.splice(index, 1)
        }
      })
    }
  },
  mounted () {
    this.doLoadFav()
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

#imgBoxListFav li {
  list-style: none;
  width: 200px;
  float: left;
  padding: 10px 5px;
}

#imgBoxListFav {
  overflow: auto;
  width: 100%;
  height: calc(100vh - 240px);
}

#resInfoFav {
  font-size: 20px;
  text-align: center;
  position: relative;
  right: 200px;
  vertical-align: middle;
  margin-top: 100px;
  color: #fff;
}
</style>
